exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2c93gXiqaa_60YyFP5Q02P{width:400px}", ""]);

// exports
exports.locals = {
	"textbox": "_2c93gXiqaa_60YyFP5Q02P"
};